import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { ActionTableCell, ExTable, TableBody, TableHead, TableWrapper } from 'components/shared/widget'
import { PcrProtocol, PcrProtocolSearchForm } from 'entities/pcr_protocol'
import { useDeletePcrProtocolApi, useFetchPcrProtocolsApi } from 'api/pcr_protocol'
import { pcrProtocolColumnInfoList, PcrProtocolTableData } from './pcr_protocol_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditPcrProtocolForm, NewPcrProtocolForm } from './pcr_protocol_form'
import { useState } from 'react'
import { SearchConditionView } from 'components/shared/search_drawer'

type Props = {
    history: H.History
}

const PcrProtocolsPage = (props: Props) => {
    const query = useQuery<PcrProtocolSearchForm>()
    const searchForm = useForm<PcrProtocolSearchForm>({ ordering: 'pcr_protocol_sample_count,pcr_protocol_probe_count', ...query })
    const listApi = useFetchPcrProtocolsApi(searchForm)
    const globalState = useContext(GlobalStateContext)
    const pcrProtocolDisplaySetting = useDisplaySetting(pcrProtocolColumnInfoList(searchForm), 'PcrProtocol')
    const deleteApi = useDeletePcrProtocolApi()
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [selectedPcrProtocol, setSelectedPcrProtocol] = useState<PcrProtocol>({})

    useEffect(() => {
        listApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteApi.loading])

    const handleClickRemoveFilter = (key: keyof PcrProtocolSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    return (
        <>
            <EditPcrProtocolForm
                show={showEdit}
                pcrProtocol={selectedPcrProtocol}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                headerTitle="PcrProtocols"
                left={
                    <>
                        <NewPcrProtocolForm onComplete={() => listApi.execute()} />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <>
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    </>
                }
            />
            <ContentBody>
                <TableWrapper>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <ActionTableCell th></ActionTableCell>
                                <ActionTableCell th></ActionTableCell>
                                <TableHeads displaySetting={pcrProtocolDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((pcrProtocol: PcrProtocol) => {
                                return (
                                    <tr key={pcrProtocol.id}>
                                        <ActionTableCell
                                            action={'delete'}
                                            onClick={() => {
                                                globalState.showConfirm('本当に削除しますか？(すでにStudyで使われている場合は削除できません)', () => {
                                                    deleteApi.execute(pcrProtocol.id!)
                                                })
                                            }}
                                        />
                                        <ActionTableCell
                                            action={'edit'}
                                            onClick={() => {
                                                setSelectedPcrProtocol(pcrProtocol)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <PcrProtocolTableData pcrProtocol={pcrProtocol} displaySetting={pcrProtocolDisplaySetting} />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(PcrProtocolsPage)
